import { type ReactNode } from 'react';
import { NavLink } from '../../../components/ui/NavLink';
import { cn } from '../../../lib/utils';

function navItemClassName(collapsed: boolean, isActive: boolean) {
  return cn(
    'flex w-full items-center rounded-xl text-sm font-medium outline-none transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600',
    collapsed ? 'justify-center px-0 py-2' : 'gap-3 px-3 py-2.5',
    isActive
      ? 'bg-[var(--color-actions-selected-light-mode)] text-foreground'
      : 'text-muted-foreground hover:bg-accent/50 hover:text-foreground',
  );
}

export type SidebarNavItemProps = {
  /** Route path (passed to `NavLink` as `href`). */
  to: string;
  end?: boolean;
  icon: ReactNode;
  label: string;
  collapsed: boolean;
  openInNewTab?: boolean;
};

export function SidebarNavItem({
  to,
  end,
  icon,
  label,
  collapsed,
  openInNewTab,
}: SidebarNavItemProps) {
  return (
    <NavLink
      href={to}
      target={openInNewTab ? '_blank' : undefined}
      end={end}
      className={({ isActive }) => navItemClassName(collapsed, isActive)}
      aria-label={collapsed ? label : undefined}
      title={collapsed ? label : undefined}
    >
      {collapsed ? (
        <span className='flex size-8 items-center justify-center text-current [&>svg]:size-5'>
          {icon}
        </span>
      ) : (
        <>
          <span className='flex size-5 shrink-0 items-center justify-center text-current [&>svg]:size-5'>
            {icon}
          </span>
          <span className='truncate'>{label}</span>
        </>
      )}
    </NavLink>
  );
}
